import { type StockStatus } from "./infer-stock-status";

/** Counts above this threshold are not shown — too many to be actionable. */
export const AVAILABILITY_COUNT_THRESHOLD = 5;

/**
 * Returns the count to display in an "X left" badge, or null when no count
 * badge is appropriate.
 *
 * Shows whichever constraint is tighter: remaining physical stock or the
 * user's personal limit. E.g. stock=2, limit-remaining=3 → 2, not 3.
 *
 * Callers must handle "reserved" / "out-of-stock" / isLimitOver separately
 * — those are danger states rendered as text badges, not counts.
 */
export function getAvailabilityCount(
  stockStatus: StockStatus,
  remaining: number | null
): number | null {
  const stockCount =
    typeof stockStatus === "number" &&
    stockStatus <= AVAILABILITY_COUNT_THRESHOLD
      ? stockStatus
      : null;

  const limitCount =
    remaining !== null && remaining <= AVAILABILITY_COUNT_THRESHOLD
      ? remaining
      : null;

  if (stockCount !== null && limitCount !== null) {
    return Math.min(stockCount, limitCount);
  }

  return stockCount ?? limitCount ?? null;
}
